import styled from 'styled-components/macro';

// utils
import mq from '../../../utils/mediaQueriesBp';

const ATCDropdownList = styled.ul`
  background-color: ${props => props.theme.colors.white};
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  margin: 0;
  text-align: center;
  padding: 17px 10px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  max-width: 158px;

  li {
    padding: 0;
    margin-bottom: 12px;

    &:last-of-type {
      margin-bottom: 0;
    }

    &:before {
      content: none;
    }

    a {
      text-decoration: none;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: ${props => props.theme.colors.primary};
      transition: all 0.5s;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export { ATCDropdownList };
